// TV4-5597: VRBO per-rental availability config
export interface VrboAvailabilityConfig {
  min_prior_notify?: number // Advance Notice Time (days), 0-999, 0 = no notice required, default 1
  min_stay?: number // Minimum Stay (nights), 0-999, 0 = use rental base rate value
  max_stay?: number // Maximum Stay (nights), 0-999, 0 = use rental base rate value
  availability_default?: string // 'Y' | 'N'
  change_over?: string // 'C' = check-in/out | 'I' = check-in only | 'O' = check-out only | 'X' = none
  stay_increment?: string // 'D' = day | 'W' = week | 'M' = month | 'Y' = year
}

import { FeeModalities } from '@tokeet-frontend/rentals'
import { isSomething } from '@tokeet-frontend/tv3-platform'
import * as lodash from 'lodash'
export interface VrboListingFee {
  pkey: string
  modality: FeeModalities
  type: string
  amount: number
  name: string
}

function getFeeModality(fee: any): FeeModalities {
  if (fee.appliesPerGuestPerNight) {
    return FeeModalities.PerPersonPerNight
  } else if (fee.appliesPerNight) {
    return FeeModalities.PerNight
  } else if (fee.appliesPerGuestPerStay) {
    return FeeModalities.PerPerson
  }
  return FeeModalities.PerStay
}

export function normalizeVrboListingLodgingRate(data: any): VrboListingFee[] {
  const { lodgingRate } = data
  const { fees, taxRules, paymentSchedule } = lodgingRate
  const feeList: VrboListingFee[] = []
  if (!isSomething(fees)) {
    return feeList
  }

  const parseFee = (fee: any, title: string = 'Fee', isPercent = false) => {
    if (!isSomething(fee)) return []

    const fees = Array.isArray(fee) ? fee : [fee]
    return fees.map((item: any) => ({
      pkey: item.externalId,
      modality: getFeeModality(item),
      type: isPercent ? 'pct' : 'flat',
      amount: isPercent ? item.percent : item.amount,
      name: item.name || title,
    }))
  }

  Object.keys(fees).forEach((key) => {
    feeList.push(...parseFee(fees[key].fee, lodash.startCase(key), /percent/i.test(key)))
  })
  return feeList
}
